import React, { useState, lazy } from 'react';
const tomos = [{
  num: '01',
  title: 'Por Qué Tu Cuerpo Se Queja',
  subtitle: 'El diagnóstico que ningún oficinista quiere ver pero todos necesitan',
  desc: 'Qué es una contractura y cómo se instala. Lo que realmente le pasa a tu cuerpo después de 8 horas sentado. Las 6 zonas más afectadas en oficinistas: cuello, trapecios, lumbar, hombros, caderas y muñecas. Los 7 errores que el 95% de los oficinistas comete sin saberlo. El test de autoevaluación de 15 preguntas que te dice exactamente en qué nivel estás y qué protocolo seguir.'
}, {
  num: '02',
  title: 'El Método de Liberación',
  subtitle: 'Cómo eliminar la tensión acumulada antes de que se convierta en dolor crónico',
  desc: 'Protocolo de Mañana de 10 minutos antes de encender la PC. Protocolo de Mediodía de 7 minutos para el pico de tensión de la jornada. Protocolo de Noche de 10 minutos para no llevarte el trabajo al cuerpo. 25 técnicas especiales organizadas por zona. El Método 30-30: la intervención más simple y más efectiva que podés hacer sin salir de tu escritorio.'
}, {
  num: '03',
  title: 'Tu Oficina Sin Gastar Una Fortuna',
  subtitle: 'El setup ergonómico correcto con lo que ya tenés o invirtiendo lo mínimo',
  desc: 'Por qué el 80% de los problemas posturales se resuelven con ajustes de 20 minutos que no cuestan nada. La altura exacta del monitor y cómo elevarlo con libros hoy mismo. Cómo regular tu silla actual correctamente. La posición exacta del teclado y el mouse. Configuración específica para home office y para oficina tradicional. Los errores invisibles del trabajo híbrido y cómo resolverlos.'
}, {
  num: '04',
  title: 'Plan 21 Días: Del Dolor al Cuerpo Libre',
  subtitle: 'El roadmap exacto, día por día, para transformar tu cuerpo en 3 semanas',
  desc: 'Semana 1: Despertar y romper el patrón de tensión instalado. Semana 2: Reprogramación de los patrones musculares. Semana 3: Consolidación definitiva del cambio. Cada día con instrucciones específicas, enfoque especial y registro de progreso. Test final de autoevaluación para medir la diferencia exacta entre el Día 1 y el Día 21.'
}];
const checklist = ['Sistema listo para implementar desde el día 1', 'Checklists y plantillas para usar de inmediato', 'Protocolos y movimientos explicados paso a paso', 'Casos reales del contexto del oficinista argentino', 'Cierre con resumen accionable por tomo', '100% adaptado a la realidad argentina 2026'];
const bonos = [{
  num: '01',
  title: 'Rutina Express: 7 Min y Listo',
  short: 'Guía visual para liberar tensión',
  desc: '7 movimientos específicos con descripción exacta. 5 variantes según tu situación: días de emergencia, cuello muy tenso, lumbar cargada, espacios compartidos y pre-reunión. Diseñada para imprimir y pegar en la pared de tu espacio de trabajo. Sin excusas: funciona en la silla, de pie, en el baño de la oficina o en la cocina mientras esperás el café.',
  value: '$8.000',
  img: 'https://images.unsplash.com/photo-1593476550610-87baa860004a?auto=format&fit=crop&w=360&q=55',
  alt: 'Oficinista haciendo rutina de estiramiento en su escritorio'
}, {
  num: '02',
  title: 'Guía del Sueño Reparador',
  short: 'Dormir para recuperar de verdad',
  desc: 'Por qué el círculo vicioso sueño malo-dolor-sueño malo destruye cualquier tratamiento. Las posiciones correctas para dormir según tu zona de dolor. Cómo optimizar la almohada y el colchón que ya tenés. Rutina pre-sueño de 5 minutos que cambia la calidad del descanso. Los 5 suplementos naturales para el descanso muscular disponibles en Argentina.',
  value: '$10.000',
  img: 'https://images.unsplash.com/photo-1520206183501-b80df61043c2?auto=format&fit=crop&w=360&q=55',
  alt: 'Persona descansando plácidamente para una recuperación reparadora'
}, {
  num: '03',
  title: 'Alimentación Anti-Inflamatoria',
  short: 'Lo que comés también te duele',
  desc: 'Los 10 alimentos que inflaman tus músculos (varios muy comunes en la dieta argentina). Los 10 alimentos que los sanan y reducen la inflamación. El rol del magnesio en la relajación muscular. Plan de alimentación de 7 días anti-inflamatorio adaptado a la cocina argentina. 7 recetas económicas y fáciles. Tabla semáforo verde-amarillo-rojo de referencia rápida.',
  value: '$10.000',
  img: 'https://images.unsplash.com/photo-1505253758473-96b7015fcd40?auto=format&fit=crop&w=360&q=55',
  alt: 'Bowl con comida anti-inflamatoria y vegetales'
}, {
  num: '04',
  title: 'Tracker Postural 30 Días',
  short: 'Seguimiento gamificado',
  desc: '30 páginas de registro diario con checklist de protocolos, hábitos y escala de dolor por zona. Sistema de puntos que convierte los hábitos en un juego con metas claras. Gráficos de progreso semanal para ver la evolución visual. Evaluaciones semanales de 5 minutos. Página de cierre con comparativa de dolor inicio vs fin.',
  value: '$8.000',
  img: 'https://images.unsplash.com/photo-1517842645767-c639042777db?auto=format&fit=crop&w=360&q=55',
  alt: 'Planificador con checklist y lápiz'
}];
function TomoCard({
  t,
  i
}: {
  t: (typeof tomos)[number];
  i: number;
}) {
  const [open, setOpen] = useState(false);
  return <div className={`bg-[#E8EDF3] border border-[#D5DCE5] rounded-2xl p-3.5 sm:p-6 md:p-10 hover:border-[#2D9596] transition-all relative overflow-hidden ${open ? 'border-[#2D9596] shadow-md' : ''}`} data-id="element-231">
      <div className="absolute top-0 right-0 w-20 h-20 sm:w-32 sm:h-32 rounded-bl-full bg-gradient-to-br from-transparent to-[#D5DCE5]/50 -mr-6 -mt-6 sm:-mr-10 sm:-mt-10" data-id="element-232" />
      <div className="relative z-10" data-id="element-233">
        <div className="flex items-baseline gap-2 sm:gap-3 mb-1.5 sm:mb-4" data-id="element-234">
          <span className="text-3xl sm:text-5xl md:text-6xl text-[#2D9596] font-light italic leading-none" style={{
          fontFamily: "'DM Serif Display', serif"
        }} data-id="element-235">
            {t.num}
          </span>
          <span className="text-[9px] sm:text-xs tracking-[0.25em] text-[#1E3A5F] font-bold uppercase" data-id="element-236">
            Tomo
          </span>
        </div>
        <h3 className="text-base sm:text-2xl md:text-3xl text-[#1A2433] mb-1 sm:mb-2 leading-tight" data-id="element-237">
          {t.title}
        </h3>
        <p className="text-[11px] sm:text-sm md:text-base text-[#1E3A5F] italic mb-1.5 sm:mb-4 leading-snug" data-id="element-238">
          {t.subtitle}
        </p>

        {/* Compact on mobile: hide desc behind toggle */}
        <div className="md:hidden" data-id="element-239">
          <div className={`grid transition-all duration-300 ease-out ${open ? 'grid-rows-[1fr] opacity-100 mt-1.5' : 'grid-rows-[0fr] opacity-0'}`} data-id="element-240">
            <div className="overflow-hidden" data-id="element-241">
              <p className="text-[#4A5568] leading-snug text-[11px]" data-id="element-242">
                {t.desc}
              </p>
            </div>
          </div>
          <button type="button" onClick={() => setOpen(!open)} className="mt-2 text-[10px] font-bold tracking-wider uppercase text-[#1E3A5F] active:text-[#2D9596] transition-colors flex items-center gap-1" aria-expanded={open} data-id="element-243">
            {open ? 'Ver menos' : 'Ver más'}
            <svg className={`w-3 h-3 transition-transform ${open ? 'rotate-180' : ''}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5} data-id="element-244">
              <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" data-id="element-245" />
            </svg>
          </button>
        </div>
        <p className="hidden md:block text-[#4A5568] leading-relaxed text-sm md:text-base" data-id="element-246">
          {t.desc}
        </p>
      </div>
    </div>;
}
function BonoCard({
  b
}: {
  b: (typeof bonos)[number];
}) {
  const [open, setOpen] = useState(false);
  return <div className={`bg-white border rounded-xl sm:rounded-2xl overflow-hidden flex flex-col shadow-sm hover:-translate-y-0.5 transition-all ${open ? 'border-[#2D9596] shadow-md' : 'border-[#D5DCE5] hover:border-[#2D9596]'}`} data-id="element-247">
      {/* Image — fixed height for compact + CLS-safe */}
      <div className="relative w-full h-20 sm:h-32 overflow-hidden bg-[#E8EDF3]" data-id="element-248">
        <img src={b.img} alt={b.alt} loading="lazy" decoding="async" width={360} height={180} className="w-full h-full object-cover" data-id="element-249" />
        <div className="absolute top-1 left-1 sm:top-2 sm:left-2 bg-white/95 backdrop-blur-sm text-[#2D9596] font-bold text-[8px] sm:text-[10px] tracking-[0.15em] sm:tracking-[0.18em] uppercase px-1.5 py-0.5 sm:px-2.5 sm:py-1 rounded-full shadow-sm" data-id="element-250">
          Bono {b.num}
        </div>
        <div className="absolute top-1 right-1 sm:top-2 sm:right-2 bg-[#1E3A5F] text-white font-bold px-1.5 py-0.5 sm:px-2.5 sm:py-1 rounded-full text-[8px] sm:text-[10px] uppercase tracking-wider shadow-sm" data-id="element-251">
          Gratis
        </div>
      </div>

      <button type="button" onClick={() => setOpen(!open)} aria-expanded={open} className="p-2.5 sm:p-4 flex-1 flex flex-col text-left" data-id="element-252">
        <h3 className="text-[11px] sm:text-base md:text-lg text-[#1A2433] mb-0.5 leading-tight font-bold" data-id="element-253">
          {b.title}
        </h3>
        <p className="text-[#1E3A5F] italic text-[9px] sm:text-xs mb-1.5 leading-snug" data-id="element-254">
          {b.short}
        </p>

        <div className={`grid transition-all duration-300 ease-out ${open ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`} data-id="element-255">
          <div className="overflow-hidden" data-id="element-256">
            <p className="text-[#4A5568] text-[10px] sm:text-xs leading-snug pb-1.5" data-id="element-257">
              {b.desc}
            </p>
          </div>
        </div>

        <div className="mt-auto pt-2 border-t border-[#D5DCE5] flex items-center justify-between" data-id="element-258">
          <span className="text-[#2D9596]/70 line-through font-mono text-[9px] sm:text-xs" data-id="element-259">
            {b.value}
          </span>
          <span className="text-[#1E3A5F] font-bold text-[8px] sm:text-[11px] uppercase tracking-wider flex items-center gap-1" data-id="element-260">
            {open ? 'Cerrar' : 'Detalles'}
            <svg className={`w-2 h-2 sm:w-2.5 sm:h-2.5 transition-transform ${open ? 'rotate-180' : ''}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5} data-id="element-261">
              <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" data-id="element-262" />
            </svg>
          </span>
        </div>
      </button>
    </div>;
}
export function SolutionSection() {
  const [checklistOpen, setChecklistOpen] = useState(false);
  return <section className="py-8 md:py-24 bg-white border-y border-[#D5DCE5]" data-id="element-263">
      <div className="max-w-6xl mx-auto px-4" data-id="element-264">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-5 md:mb-16" data-id="element-265">
          <div className="inline-flex items-center gap-1.5 px-2.5 py-1 sm:px-4 sm:py-2 rounded-full bg-[#E8EDF3] text-[#2D9596] font-bold text-[9px] sm:text-xs tracking-[0.15em] sm:tracking-[0.2em] uppercase mb-3 sm:mb-6 border border-[#D5DCE5]" data-id="element-266">
            🏆 Kit Anticontracturas™
          </div>
          <h2 className="text-2xl sm:text-4xl md:text-6xl text-[#1A2433] mb-2 sm:mb-4 leading-tight" data-id="element-267">
            4 Tomos <span className="italic" data-id="element-268">+</span> 4 Bonos
          </h2>
          <p className="text-sm sm:text-lg md:text-xl text-[#4A5568] italic" data-id="element-269">
            El Sistema N°1 para Oficinistas Argentinos
          </p>
          <p className="text-[10px] sm:text-sm text-[#2D9596] mt-1.5 sm:mt-3 tracking-wider uppercase" data-id="element-270">
            +300 páginas — Listo para implementar
          </p>
        </div>

        {/* Tomos Grid */}
        <div className="grid sm:grid-cols-2 gap-2.5 sm:gap-5 md:gap-6 mb-6 md:mb-16" data-id="element-271">
          {tomos.map((t, i) => <TomoCard key={i} t={t} i={i} data-id="element-272" />)}
        </div>

        {/* Checklist — collapsible on mobile */}
        <div className="max-w-3xl mx-auto bg-[#E8EDF3] border border-[#D5DCE5] rounded-2xl md:rounded-3xl p-4 sm:p-6 md:p-10 mb-8 md:mb-28" data-id="element-273">
          <button type="button" onClick={() => setChecklistOpen(!checklistOpen)} className="md:hidden w-full flex items-center justify-between gap-3 text-left" aria-expanded={checklistOpen} data-id="element-274">
            <h3 className="text-base sm:text-2xl text-[#1A2433] leading-tight" data-id="element-275">
              ✓ Cada tomo incluye:
            </h3>
            <svg className={`w-4 h-4 text-[#2D9596] shrink-0 transition-transform ${checklistOpen ? 'rotate-180' : ''}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5} data-id="element-276">
              <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" data-id="element-277" />
            </svg>
          </button>
          <h3 className="hidden md:block text-2xl md:text-3xl text-[#1A2433] mb-8 text-center" data-id="element-278">
            Cada tomo incluye:
          </h3>
          <div className={`md:!grid md:grid-cols-2 gap-2 sm:gap-3 md:gap-4 transition-all duration-300 ${checklistOpen ? 'grid grid-cols-1 mt-3' : 'hidden md:grid'}`} data-id="element-279">
            {checklist.map((item, i) => <div key={i} className="flex items-start gap-2" data-id="element-280">
                <span className="text-[#2D9596] mt-0.5 shrink-0 text-xs sm:text-base" data-id="element-281">
                  ✓
                </span>
                <span className="text-[#4A5568] font-medium text-[11px] sm:text-sm md:text-base leading-snug" data-id="element-282">
                  {item}
                </span>
              </div>)}
          </div>
        </div>

        {/* Bonuses Header */}
        <div className="text-center max-w-3xl mx-auto mb-5 sm:mb-12" data-id="element-283">
          <div className="text-[9px] sm:text-[10px] tracking-[0.25em] sm:tracking-[0.3em] text-[#2D9596] font-bold uppercase mb-2 sm:mb-3" data-id="element-284">
            🎁 Siempre incluidos
          </div>
          <h2 className="text-2xl sm:text-4xl md:text-6xl text-[#1A2433] mb-2 sm:mb-4 leading-tight" data-id="element-285">
            4 Bonos <span className="italic" data-id="element-286">de Acción Inmediata</span>
          </h2>
        </div>

        {/* Bonuses Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-2.5 sm:gap-5 mb-6 md:mb-16" data-id="element-287">
          {bonos.map((b, i) => <BonoCard key={i} b={b} data-id="element-288" />)}
        </div>

        {/* Total Value */}
        <div className="max-w-xl mx-auto text-center bg-[#E8EDF3] border border-[#2D9596]/40 rounded-2xl p-4 sm:p-6 md:p-8" data-id="element-289">
          <div className="text-[#2D9596] font-bold mb-1.5 sm:mb-2 uppercase tracking-[0.2em] text-[9px] sm:text-xs" data-id="element-290">
            Valor total bonos
          </div>
          <div className="text-lg sm:text-2xl md:text-3xl" data-id="element-291">
            <span className="line-through text-[#4A5568]/60 mr-2 sm:mr-3" data-id="element-292">
              $36.000
            </span>
            <span className="text-[#1E3A5F] italic" data-id="element-293">→ Gratis con tu Kit</span>
          </div>
        </div>
      </div>
    </section>;
}